import { Component, OnInit } from '@angular/core';
import { AppService } from '@services/app.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  public activeTabSubject = new BehaviorSubject<string>('ACTIVITY');
  activeTab$ = this.activeTabSubject.asObservable();

  public user;

  constructor(private appService: AppService) {
    this.user = this.appService.user;
  }

  ngOnInit(): void {
    if (!this.user) {
      this.user = this.appService.user;
    }
  }

  setActiveTab(tab: string) {
    this.activeTabSubject.next(tab);
  }

  toggle(tab: string) {
    this.setActiveTab(tab);
  }
}
